export var LoggerConnectionStatus;
(function (LoggerConnectionStatus) {
    LoggerConnectionStatus[LoggerConnectionStatus["Connecting"] = 0] = "Connecting";
    LoggerConnectionStatus[LoggerConnectionStatus["Connected"] = 1] = "Connected";
    LoggerConnectionStatus[LoggerConnectionStatus["Closed"] = 2] = "Closed";
})(LoggerConnectionStatus || (LoggerConnectionStatus = {}));
;
export class Logger {
    constructor({ wssEndpoint, source = 'unknown', prefix, developmentMode = false }) {
        this.source = 'unknown';
        this.status = LoggerConnectionStatus.Closed;
        this.LOGLEVEL = {
            ERROR: 'error',
            WARN: 'warn',
            INFO: 'info',
            DEBUG: 'debug',
            METRIC: 'metric'
        };
        this.source = source;
        this.prefix = prefix;
        if (!wssEndpoint) {
            const message = 'Missing LOGGER_WSS_ENDPOINT environment variable. Logger will print to the console only.';
            if (!developmentMode) {
                console.error(message);
            }
            else {
                console.info(message);
            }
            return;
        }
        if (wssEndpoint.endsWith('/')) {
            console.warn(`LOGGER_WSS_ENDPOINT environment variable is invalid due to a trailing slash: ${wssEndpoint}`);
            return;
        }
        try {
            this.messageQueue = [];
            this.status = LoggerConnectionStatus.Connecting;
            this.logSocket = new WebSocket(wssEndpoint);
            this.logSocket.onopen = () => {
                this.status = LoggerConnectionStatus.Connected;
                console.log('Logger connection established');
                // Flush queued messages
                for (const message of this.messageQueue) {
                    this.logSocket.send(message);
                }
                this.messageQueue = undefined;
            };
            this.logSocket.onclose = () => {
                this.messageQueue = undefined;
                this.status = LoggerConnectionStatus.Closed;
                console.warn('Connection Closed');
            };
            this.logSocket.onerror = () => {
                this.messageQueue = undefined;
                this.status = LoggerConnectionStatus.Closed;
                console.error('Connection Error');
            };
        }
        catch (exception) {
            this.logSocket = undefined;
            this.messageQueue = undefined;
            this.status = LoggerConnectionStatus.Closed;
            console.error(`An error occurred while initializing the logger: ${exception}`);
        }
    }
    error(message) {
        this.send(this.LOGLEVEL.ERROR, message);
    }
    warn(message) {
        this.send(this.LOGLEVEL.WARN, message);
    }
    info(message) {
        this.send(this.LOGLEVEL.INFO, message);
    }
    debug(message) {
        this.send(this.LOGLEVEL.DEBUG, message);
    }
    metric(metric, identifier, value) {
        this.send(this.LOGLEVEL.METRIC, { metric, identifier, value }, 'metric');
    }
    send(level, message, type = 'log') {
        let stringifiedMessage;
        if (typeof message === 'string') {
            stringifiedMessage = message;
        }
        else {
            stringifiedMessage = JSON.stringify(message, null, 2);
        }
        const finalMessage = this.prefix ? this.prefix + stringifiedMessage : stringifiedMessage;
        if (level in console) {
            console[level](finalMessage);
        }
        if (this.status === LoggerConnectionStatus.Closed) {
            return;
        }
        const logMessage = JSON.stringify({
            type,
            level,
            time: Date.now(),
            source: this.source,
            message: finalMessage
        });
        if (this.status === LoggerConnectionStatus.Connecting) {
            this.messageQueue.push(logMessage);
            console.log(`Awaiting logger socket connection, message enqueued: ${finalMessage}`);
            return;
        }
        this.logSocket.send(logMessage);
    }
}
